/**
 * Generated by orval 🍺
 * Do not edit manually.
 * QPM API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  CalendarConnectionOut,
  ConnectRequest,
  HTTPValidationError
} from '../../models';

import { customMutator } from '../../api.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Same exchange against Microsoft Graph. Stored as provider OUTLOOK.
 * @summary Connect Microsoft Calendar
 */
export const connectMicrosoftCalendar = (
    connectRequest: ConnectRequest,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {


      return customMutator<CalendarConnectionOut>(
      {url: `/calendar/microsoft/connect`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: connectRequest, signal
    },
      options);
    }




export const getConnectMicrosoftCalendarMutationKey = () => ['connectMicrosoftCalendar'] as const;

export const getConnectMicrosoftCalendarMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectMicrosoftCalendar>>, TError,ConnectMicrosoftCalendarMutationVariables, TContext>, request?: SecondParameter<typeof customMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof connectMicrosoftCalendar>>, TError,ConnectMicrosoftCalendarMutationVariables, TContext> => {

const mutationKey = getConnectMicrosoftCalendarMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof connectMicrosoftCalendar>>, ConnectMicrosoftCalendarMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  connectMicrosoftCalendar(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConnectMicrosoftCalendarMutationResult = NonNullable<Awaited<ReturnType<typeof connectMicrosoftCalendar>>>
    export type ConnectMicrosoftCalendarMutationBody = ConnectRequest
    export type ConnectMicrosoftCalendarMutationError = HTTPValidationError
    export type ConnectMicrosoftCalendarMutationVariables = {data: ConnectRequest}

    /**
 * @summary Connect Microsoft Calendar
 */
export const useConnectMicrosoftCalendar = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof connectMicrosoftCalendar>>, TError,ConnectMicrosoftCalendarMutationVariables, TContext>, request?: SecondParameter<typeof customMutator>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof connectMicrosoftCalendar>>,
        TError,
        ConnectMicrosoftCalendarMutationVariables,
        TContext
      > => {
      return useMutation(getConnectMicrosoftCalendarMutationOptions(options));
    }
